// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1282":"8afa7f57","4350":"10e33f0b","7918":"95e114fd","9086":"963f27a7"}[chunkId] + ".css";
};